import { AppContext } from "@lib/types";
import { getRoute } from "@lib/helpers/RouteHelper";
import { ROUTES } from "@lib/constants";
import { AIWallet } from "@lib/types/Wallet";

type Props = {
  context: AppContext;
  customerId?: string;
  leadId?: string;
  item: AIWallet;
};

export const getWalletLinkNoFilter = (context: AppContext) => {
  switch (context) {
    case AppContext.CUSTOMER:
      return getRoute(ROUTES.AI_PAYMENTS.WALLET_LIST);
    case AppContext.CUSTOMER_LEAD:
      return getRoute(ROUTES.AI_PAYMENTS.WALLET_LIST);
    default:
      return getRoute(ROUTES.AI_PAYMENTS.WALLET_LIST);
  }
};

export const getWalletLink = (props: Props) => {
  const { context, customerId, leadId, item } = props;

  switch (context) {
    case AppContext.CUSTOMER:
      return getRoute(ROUTES.AI_PAYMENTS.WALLET_ID, {
        [ROUTES.URL_PARAMS.WALLET_ID]: item.id,
        [ROUTES.URL_PARAMS.CUSTOMER_ID]: customerId,
      });

    case AppContext.CUSTOMER_LEAD:
      return getRoute(ROUTES.AI_PAYMENTS.WALLET_ID, {
        [ROUTES.URL_PARAMS.WALLET_ID]: item.id,
        [ROUTES.URL_PARAMS.CUSTOMER_LEAD_ID]: leadId,
        [ROUTES.URL_PARAMS.CUSTOMER_ID]: customerId,
      });

    default:
      return getRoute(ROUTES.AI_PAYMENTS.WALLET_ID, {
        [ROUTES.URL_PARAMS.WALLET_ID]: item.id,
      });
  }
};
